export function suggestJsonPath(_root, pointer) {
    const parts = [];
    for (const p of pointer) {
        if (typeof p === 'number') {
            const prev = parts[parts.length - 1] ?? '';
            parts[parts.length - 1] = `${prev}[${p}]`;
        }
        else {
            if (parts.length === 0)
                parts.push(p);
            else
                parts.push('.' + p);
        }
    }
    const path = parts.join('');
    const tail = pointer[pointer.length - 1];
    const last = typeof tail === 'string' ? tail : `index ${tail}`;
    return { path, description: `the ${last} value` };
}
//# sourceMappingURL=json-suggest.js.map